// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"495830bd","754":"d8de2f90"}[chunkId] + ".chunk.css";
};